var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 733 450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.326,150.452C137.419,150.452 145.671,144.995 145.671,138.297C145.671,131.886 137.33,123.324 133.071,118.089L121.891,118.089L129.167,126.185C128.546,126.163 127.947,126.141 127.326,126.141C117.211,126.141 108.982,130 108.982,138.297C108.982,144.995 117.211,150.452 127.326,150.452Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.173,126.828L86.556,126.828L86.556,139.871C86.556,146.526 97.447,146.526 97.447,139.871L97.447,126.828L106.608,126.828L106.608,140.759C106.608,154.467 77.173,154.356 77.173,140.759L77.173,126.828Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.844,
    y: 126.828,
    width: 10.071,
    height: 23.535,
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.053,118.909L57.408,118.909L79.147,150.363L67.79,150.363L64.706,145.506L44.033,145.506L41.083,150.363L30.213,150.363L48.314,122.88L45.053,118.909Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.789,43.114C170.936,43.358 184.733,57.532 184.511,74.679C184.267,91.825 170.093,105.6 152.946,105.378C146.003,105.29 139.593,102.894 134.469,98.968C129.101,103.094 122.357,105.534 115.081,105.423C108.116,105.334 101.728,102.938 96.604,98.99C91.236,103.138 84.493,105.578 77.217,105.467C70.296,105.378 63.908,103.005 58.784,99.101C53.438,103.205 46.717,105.6 39.485,105.511C22.339,105.268 8.541,91.116 8.763,73.969C9.007,56.822 23.182,43.025 40.328,43.247C47.249,43.358 53.615,45.709 58.739,49.613C64.107,45.531 70.806,43.114 78.038,43.225C85.003,43.313 91.414,45.709 96.538,49.657C101.883,45.509 108.649,43.069 115.925,43.18C122.867,43.269 129.256,45.643 134.402,49.591C139.77,45.443 146.513,43.025 153.789,43.114Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.824,54.781L134.58,50.855C139.482,46.907 145.626,44.489 152.303,44.245C152.547,44.6 153.567,46.663 153.745,46.663C168.54,47.35 180.363,56.223 180.962,74.634C181.428,89.829 168.185,102.029 152.991,101.829C145.826,101.718 139.304,98.879 134.446,94.31C129.101,99.123 122.623,101.984 115.126,101.874C107.961,101.785 101.462,98.945 96.626,94.376C91.458,99.212 84.404,102.029 77.261,101.918C70.385,101.829 63.753,99.123 58.784,94.487C58.007,95.219 57.076,95.973 56.033,96.728C51.397,100.099 45.674,102.051 39.53,101.962C28.261,101.807 18.612,94.864 14.486,85.082C13.421,84.993 12.468,84.793 11.647,84.55C10.471,81.245 9.828,77.695 9.872,73.991C10.094,57.931 22.982,44.932 38.842,44.378C39.286,45.021 39.752,45.82 40.151,46.796L40.284,46.796C47.382,46.907 54.148,49.746 59.205,54.715L58.983,50.833C63.863,46.973 69.964,44.578 76.574,44.356C76.818,44.711 77.461,45.554 77.993,46.774C84.936,46.862 92.012,49.923 96.937,54.626L96.715,50.922C101.595,46.973 107.762,44.533 114.438,44.311C114.882,44.955 115.326,45.753 115.747,46.729L115.88,46.729C122.867,46.818 129.833,50.012 134.824,54.781Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.262,48.348C25.91,48.171 14.065,59.706 13.865,74.035C13.71,86.546 22.45,97.127 34.184,99.766C34.583,99.256 35.027,98.702 35.47,98.147C36.801,98.391 38.177,98.524 39.574,98.546C45.031,98.613 50.066,96.883 54.392,93.666L58.007,93.733C55.567,91.249 53.571,88.298 52.196,85.038C51.131,84.949 50.199,84.771 49.379,84.527C48.181,81.222 47.538,77.651 47.604,73.947C47.693,67.092 50.088,60.793 54.059,55.779C55.59,55.735 57.142,55.713 58.029,55.713C53.305,51.121 46.961,48.437 40.262,48.348Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.883,93.223C48.78,87.877 46.384,81.178 46.495,73.947C46.584,67.004 48.957,60.638 52.883,55.491C49.268,53.007 44.92,51.521 40.217,51.454C27.596,51.299 17.148,61.458 16.971,74.08C16.815,86.723 26.975,97.127 39.596,97.304C45.342,97.371 50.088,95.064 52.883,93.223Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.806,56.489C54.48,61.081 51.774,67.225 51.597,74.013C51.464,78.605 53.238,85.881 56.743,89.94C57.408,90.716 57.941,91.581 58.85,92.38L58.939,89.075C62.288,85.082 64.019,79.936 64.085,74.723C64.107,71.995 63.708,69.377 62.91,66.937C63.398,65.651 64.307,64.963 64.307,64.963C63.464,61.946 61.024,58.774 58.806,56.489Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.582,56.489C92.256,61.059 89.573,67.203 89.484,73.969C89.395,81.045 92.168,87.522 96.715,92.291L96.804,89.208C99.598,84.705 101.706,80.357 101.772,74.679C101.817,71.972 101.395,69.355 100.597,66.893C101.085,65.606 102.016,64.919 102.016,64.919C101.284,62.345 98.667,58.574 96.582,56.489Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.784,87.389C56.144,83.596 54.636,79.004 54.702,74.058C54.769,69.333 56.255,64.963 58.762,61.347C61.379,65.14 62.91,69.754 62.843,74.701C62.777,79.403 61.29,83.773 58.784,87.389Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.788,55.691L133.692,55.713C128.834,51.143 122.69,48.371 115.858,48.282C108.804,48.193 102.349,50.922 97.624,55.425C102.549,60.549 105.299,67.558 105.188,74.723C105.1,81.555 102.371,88.343 97.735,93.289C101.04,96.395 105.166,98.657 109.78,99.7C110.179,99.167 110.623,98.613 111.067,98.058C112.398,98.302 113.773,98.436 115.17,98.458C121.071,98.546 126.039,96.395 130.254,93.555L133.581,93.467C131.208,91.004 129.278,88.121 127.925,84.949C126.86,84.86 125.929,84.661 125.108,84.416C123.91,81.111 123.289,77.562 123.333,73.858C123.422,67.004 125.84,60.704 129.788,55.691Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.193,97.215C110.445,97.149 106.053,95.663 102.416,93.134C106.297,88.01 108.649,81.666 108.738,74.767C108.848,67.558 106.453,60.882 102.371,55.535C106.187,52.852 110.823,51.321 115.814,51.387C120.538,51.454 124.93,52.962 128.546,55.469C124.664,60.593 122.313,66.937 122.224,73.836C122.136,81.045 124.509,87.744 128.591,93.09C125.796,94.931 121.004,97.304 115.193,97.215Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.768,64.83C177.768,64.83 176.836,65.517 176.348,66.804C177.147,69.244 177.568,71.862 177.546,74.59C177.346,87.899 166.344,98.591 153.035,98.413C151.638,98.391 150.262,98.258 148.931,97.992C148.488,98.568 148.044,99.123 147.645,99.633C143.031,98.591 138.905,96.328 135.578,93.245C140.325,88.476 143.009,81.333 143.097,74.679C143.186,67.536 140.414,60.504 135.489,55.336C140.258,50.855 146.691,48.127 153.723,48.216C165.279,48.216 175.705,57.488 177.768,64.83Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.903,64.874C139.903,64.874 138.994,65.562 138.483,66.848C139.304,69.311 139.704,71.928 139.681,74.634C139.593,80.623 138.062,84.661 134.735,89.208L134.69,92.38C130.054,87.588 127.237,81.067 127.326,73.902C127.415,67.137 130.099,61.014 134.402,56.423C136.62,58.685 139.082,61.902 139.903,64.874Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.678,51.321C166.3,51.498 176.459,61.946 176.304,74.568C176.126,87.189 165.679,97.326 153.057,97.171C148.332,97.105 143.94,95.618 140.302,93.09C144.207,87.988 146.536,81.622 146.647,74.723C146.735,67.514 144.34,60.815 140.258,55.469C144.051,52.807 148.687,51.255 153.678,51.321Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.446,87.211C131.851,83.441 130.365,78.849 130.432,73.947C130.498,69.288 131.962,64.963 134.402,61.369C136.997,65.14 138.506,69.71 138.439,74.612C138.373,79.293 136.909,83.618 134.446,87.211Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.582,87.234C94.009,83.463 92.523,78.893 92.589,74.013C92.656,69.355 94.12,65.03 96.56,61.436C99.111,65.207 100.597,69.776 100.53,74.657C100.464,79.315 99.022,83.64 96.582,87.234Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.971,48.326C70.962,48.238 64.595,50.944 59.871,55.425C64.773,60.66 67.59,67.248 67.501,74.767C67.413,81.71 64.618,88.431 59.871,93.4C63.176,96.506 67.479,98.746 71.916,99.744C72.315,99.212 72.736,98.657 73.202,98.103C74.533,98.347 75.908,98.48 77.306,98.502C82.186,98.568 88.53,96.927 92.256,93.555L95.761,93.533C93.388,91.093 91.436,88.187 90.082,84.993C89.018,84.905 88.086,84.727 87.265,84.483C86.068,81.178 85.447,77.607 85.491,73.902C85.58,67.048 87.998,60.748 91.968,55.735L95.695,55.647C90.748,51.077 84.914,48.415 77.971,48.326Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.328,97.26C72.625,97.193 68.278,95.752 64.662,93.245C68.588,88.121 70.962,81.732 71.05,74.812C71.139,67.558 68.721,60.837 64.618,55.491C68.411,52.874 73.002,51.365 77.927,51.432C82.674,51.498 87.066,53.007 90.704,55.535C86.822,60.66 84.47,67.004 84.382,73.902C84.293,81.089 86.666,87.766 90.726,93.112C87.953,94.975 83.14,97.348 77.328,97.26Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.326,144.33C132.14,144.33 136.066,141.513 136.066,138.053C136.066,134.592 132.14,131.775 127.326,131.775C122.513,131.775 118.564,134.592 118.564,138.053C118.564,141.513 122.513,144.33 127.326,144.33Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-36.5015,-179.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.647,139.095L54.148,128.803L47.915,139.095L60.647,139.095Z",
    style: {
      fill: "white"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudi);
export default __webpack_public_path__ + "static/media/Audi.217d824f56bfd34f1ba8ce74c7f509dc.svg";
export { ForwardRef as ReactComponent };